module.exports = __webpack_public_path__ + "img/sierraint5.14cebf2f.png";